import {
  Component
} from '@angular/core';


export class SkyToolbarItemComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-toolbar-item',
  styles: [`.sky-toolbar-item {
  margin-right: 5px;
}
`],
  template: `<div class="sky-toolbar-item">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
